const prototype = {
    billing_full_address: null,
    billing_name: null,
    billing_sub_address: null,
    //cancelable_until: undefined,
    //client_secret: undefined,
    cloudcanteen_id: null,
    comment: null,
    company_name: null,
    expense_code: null,
    coupon_code: null,
    //created_at: undefined,
    delivery_full_address: null,
    delivery_name: null,
    delivery_sub_address: null,
    group_order_employees: [],
    group_order_sum_distribution: {},
    items: [],
    latitude: 0,
    longitude: 0,
    //order_status: undefined,
    payment_method: null,
    phone: null,
    phone_is_valid: null,
    //price_coupon_discount: undefined,
    //price_sum_items: '',
    //redirect_url: undefined,
    required_delivery_time: null,
    restaurant: null,
    residentialcanteen_id: null,
    selected_expense_rule: null,
    //usable_expense_rules: [
    // {
    //     budget_limit: 0,
    //     expense_code_required: 0,
    //     name: undefined,
    //     expense_code_list: [],
    //     expense_code_only_from_list: true,
    //     budget: 0,
    //     description: undefined,
    //     can_group_order: true,
    //     group_available_balances: [],
    //     type: undefined,
    //     time_unit: undefined,
    //     time_value: 0,
    //     open: undefined,
    //     close: undefined
    // }
    //]
}
const reset = {
    cloudcanteen_id: null,
    expense_code: null,
    coupon_code: null,
    group_order_employees: [],
    group_order_sum_distribution: {},
    items: [],
    payment_method: null,
    phone: null,
    phone_is_valid: null,
    restaurant: null,
    residentialcanteen_id: null,
    selected_expense_rule: null,
    billing_full_address: null,
    billing_name: null,
    billing_sub_address: null,
}
export { prototype, reset }
